module.exports = __webpack_public_path__ + "media/images/map-ec82bc24bd68a27bcf49729c13968a79.jpg";